import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export const BoxCheck = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 448 512"
      {...props}
    >
      <path
        opacity={0.2}
        fill={props.htmlColor || theme.palette.secondary[500]}
        d="M32 160l0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256-384 0zm7.3-32l168.7 0 0-80-95.1 0c-10.3 0-20 5-26 13.4L39.3 128zM147.2 313.6c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2l34 45.3 67.6-108.2c4.7-7.5 14.6-9.8 22-5.1s9.8 14.6 5.1 22l-80 128c-2.8 4.5-7.6 7.3-12.9 7.5s-10.3-2.2-13.5-6.4l-48-64zM240 48l0 80 168.7 0-47.6-66.6c-6-8.4-15.7-13.4-26-13.4L240 48z"
      />
      <path
        fill={props.htmlColor || theme.palette.secondary[500]}
        d="M416 160l-384 0 0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256zM208 128l0-80-95.1 0c-10.3 0-20 5-26 13.4L39.3 128 208 128zm200.7 0L361.1 61.4c-6-8.4-15.7-13.4-26-13.4l-95.1 0 0 80 168.7 0zM0 148.5c0-13.3 4.2-26.3 11.9-37.2L60.9 42.8C72.9 26 92.3 16 112.9 16l222.1 0c20.7 0 40.1 10 52.1 26.8l48.9 68.5c7.8 10.9 11.9 23.9 11.9 37.2L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 148.5zm301.6 100l-80 128c-2.8 4.5-7.6 7.3-12.9 7.5s-10.3-2.2-13.5-6.4l-48-64c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2l34 45.3 67.6-108.2c4.7-7.5 14.6-9.8 22-5.1s9.8 14.6 5.1 22z"
      />
    </SvgIcon>
  );
};
